import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getSubmitChartSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { SubmitChartConstants } from '../store/submitChart.constants'
import { ISubmitChartState } from '../store/submitChart.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { deletePCR } from '../../home/store/home.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveSubmitChart() {
  const submitChart: ISubmitChartState = yield select(getSubmitChartSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated = { ...pcrDoc, submitChart }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      const { success, prid } = submitChart
      if (success && prid) {
        yield put(deletePCR(pcrID))
      }
    } catch (e) {
      yield put(throwPcrException(`saveSubmitChart() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveSubmitChartSaga() {
  yield takeLatest([SubmitChartConstants.SET_POST_SUBMIT_CHART], performWithMutexHOG, saveSubmitChart)
}
